import { Quote } from 'types/payments'
import { ConvertTransferResponse } from 'types/wallets'

export const transferToQuote = (transfer: ConvertTransferResponse): Quote => {
  const { conversion, fees } = transfer
  const processingFee = fees?.processingFee ? Number(fees.processingFee) : 0
  const spreadAmount = conversion?.spread?.amount ? Number(conversion.spread.amount) : 0

  const quote: Partial<Quote> = {
    uuid: transfer.id,
    digest: conversion?.digest,
    from: transfer.originator?.currency,
    to: transfer.beneficiary?.currency,
    amountIn: Number(transfer.originator?.amount),
    amountDue: Number(transfer.originator?.amount),
    amountOut: Number(transfer.beneficiary?.amount),
    price: Number(conversion?.allInRate),
    acceptanceExpiryDate: Date.parse(conversion?.expiresAt),
    quoteStatus: transfer.status,
    paymentStatus: transfer.status,
    fee: spreadAmount,
    processingFee,
  }

  return quote as Quote
}
